import type { ClassDefinition } from '../../shared/game/class-types.js';

// Hunter 3.0 draft, level 1. Thrill of the Hunt and subclasses begin at later levels and are not implemented yet.
export const hunter: ClassDefinition = {
  id: 'hunter', name: 'Hunter',
  summary: 'A master of the wild, adept at ranged attacks and high burst damage up close.',
  keyStats: ['dexterity', 'will'], hitDie: 8, startingHp: 13,
  saves: { advantage: ['dexterity'], disadvantage: ['intelligence'] },
  armor: ['leather'], weapons: ['dexterity'],
  startingGear: ['Shortbow', 'Cheap Hides', 'Dagger', 'Hunting Trap'],
  abilities: [{
    id: 'hunters-mark', name: 'Hunter’s Mark', level: 1, actions: 1, target: 'enemy', autocast: true,
    description: 'Mark a creature you can see as your Quarry until you mark another. Your attacks against it gain advantage or +LVL damage.',
  }],
  passives: [{ id: 'forager', name: 'Forager', level: 1, description: 'Advantage on skill checks to find food and water in the wild.' }],
};
